// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".glow-tag-img[data-v-2f1f02c6]{border-radius:10px;border:2px solid #9b9b9b;height:auto;width:100%}.no-stock[data-v-2f1f02c6]{position:relative}.no-stock img[data-v-2f1f02c6]{width:100%;filter:grayscale(80%)}.no-stock svg[data-v-2f1f02c6]{width:90%;height:90%;position:absolute;top:5%;left:5%}.no-stock svg line[data-v-2f1f02c6]{stroke:#979797;stroke-width:4}", ""]);
// Exports
module.exports = exports;
